import * as ActionTypes  from '../actions';
import * as ActionPartnerTypes from '../actions/partner';
import * as DownloadTypes from '../actions/download';

const defaultDownloadState = { isDownloading: false };

const defaultState = {
  accounts: [],
  ages: [],
  cohorts: {},
  subgroups: {},
  groups: [],
  partners: [],
  players: [],
  teachers: [],
  skills: [],
  organizationTypes: [],
  periods: [],
  download: defaultDownloadState,
  download_asq2: defaultDownloadState,
  download_asq3: defaultDownloadState,
  withScope: { group: null, cohort: null },
};

export default function filters(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SURVEYS_FILTER_RECEIVE: {
      const { cohorts, subgroups, groups, teachers, withScope } = action.payload;
      return { ...state, cohorts, subgroups, groups, teachers, withScope };
    }
    case ActionTypes.PLAYERS_FILTER_RECEIVE:
      if (action.meta.source === 'modal') return state;
      return { ...state, ...action.payload };
    case ActionPartnerTypes.DASHBOARD_FILTER_RECEIVE: {
      const { groups, subgroups, cohorts, ages, partners, skills, periods, withScope } = action.payload;
      return { ...state, groups, subgroups, cohorts, ages, skills, partners, periods, withScope };
    }
    case ActionPartnerTypes.ACCOUNT_PLAYERS_FILTER_RECEIVE: {
      const { accounts, ages, groups, subgroups, cohorts, partners, withScope } = action.payload;
      return { ...state, accounts, ages, groups, subgroups, cohorts, partners, withScope };
    }
    case ActionPartnerTypes.REPORT_GROUP_COHORT_FILTER_RECEIVE: {
      const { ages, groups, withScope, periods } = action.payload;
      return { ...state, ages, groups, withScope, periods };
    }
    case ActionPartnerTypes.REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_RECEIVE: {
      const { ages, organizationTypes, periods } = action.payload;
      return { ...state, ages, organizationTypes, periods };
    }
    case DownloadTypes.ASQ_CSV_REPORT_REQUEST:
      if (action.meta.asq === 'asq_se2') {
        return {...state, download_asq2: { isDownloading: true } };
      } else {
        return {...state, download_asq3: { isDownloading: true } };
      }
    case DownloadTypes.ASQ_CSV_REPORT_RECEIVE:
      if (action.meta.asq === 'asq_se2') {
        return {...state, download_asq2: { isDownloading: false } };
      } else {
        return {...state, download_asq3: { isDownloading: false } };
      }
    case ActionTypes.API_FAILURE:
      return { ...state, download: defaultDownloadState, download_asq2: defaultDownloadState, download_asq3: defaultDownloadState };
    default:
      return state;
  }
}
